import request from '@/utils/request'
import axios from 'axios'
import { getToken } from '@/utils/auth'
import { Message } from 'element-ui'

export function fetchApList(params) {
  return request({
    url: '/fin/settlements/ap',
    method: 'get',
    params: params
  })
}

/** 未结清应付账单数量（侧栏角标，与付款申请 pending-count 用法一致） */
export function fetchApPendingCount() {
  return request({
    url: '/fin/settlements/ap/pending-count',
    method: 'get'
  })
}

export function batchPayment(data) {
  // convert array to string if needed, or send as application/x-www-form-urlencoded
  return request({
    url: '/fin/settlements/batch-payment',
    method: 'post',
    // In mall-tiny form-url-encoded is typically used for @RequestParam
    params: data
  })
}

export function createSettlement(data) {
  return request({
    url: '/fin/settlements/create',
    method: 'post',
    data: data
  })
}

export function getSettlement(id) {
  return request({
    url: '/fin/settlements/' + id,
    method: 'get'
  })
}

/** 管理员：已结清账单向其他角色开放明细与操作 */
export function unlockApSettledDetail(id) {
  return request({
    url: '/fin/settlements/' + id + '/ap-detail-unlock',
    method: 'post'
  })
}

/** 管理员：已解锁的已结清账单重新上锁 */
export function lockApSettledDetail(id) {
  return request({
    url: '/fin/settlements/' + id + '/ap-detail-lock',
    method: 'post'
  })
}

/** 管理员：已结清应付账单标记为未结清（撤销结清付款流水）；使用 /ap/revert-settled 与 pending-count 同前缀，避免部分环境下路径变量子路径 404 */
export function markApUnsettled(id) {
  return request({
    url: '/fin/settlements/ap/revert-settled',
    method: 'post',
    params: { id }
  })
}

/** 管理员：批量将已结清应付账单标记为未结清 */
export function batchMarkApUnsettled(ids) {
  const params = new URLSearchParams()
  ;(ids || []).forEach(id => {
    if (id != null && id !== '') params.append('ids', String(id))
  })
  return request({
    url: '/fin/settlements/ap/batch-revert-settled',
    method: 'post',
    params
  })
}

export function fetchSettlementRecords(settlementId) {
  return request({
    url: '/fin/settlement-records/list/' + settlementId,
    method: 'get'
  })
}

export function saveSettlementVcc(id, data) {
  return request({
    url: '/fin/settlements/' + id + '/vcc',
    method: 'post',
    data: data
  })
}

/** 银行转账：保存转账记录 */
export function saveBankTransferRecord(id, data) {
  return request({
    url: '/fin/settlements/' + id + '/bank-transfer-record',
    method: 'post',
    data: data || {}
  })
}

export function removeSettlementVcc(id) {
  return request({
    url: '/fin/settlements/' + id + '/vcc',
    method: 'delete'
  })
}

/** 下载 VCC 付款 PDF（绕过通用 response 拦截器，使用 blob） */
export function downloadVccPdf(id) {
  const base = process.env.BASE_API || ''
  return axios({
    url: `${base}/fin/settlements/${id}/vcc/pdf`,
    method: 'get',
    responseType: 'blob',
    headers: getToken() ? { Authorization: getToken() } : {},
    timeout: 120000
  }).then(res => {
    const blob = res.data
    const ct = res.headers && (res.headers['content-type'] || res.headers['Content-Type'])
    if (ct && String(ct).indexOf('application/json') >= 0) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => {
          try {
            const j = JSON.parse(reader.result)
            Message.error(j.message || '下载失败')
            reject(new Error(j.message || 'error'))
          } catch (e) {
            reject(e)
          }
        }
        reader.readAsText(blob)
      })
    }
    return blob
  })
}

/**
 * 发送财务 VCC 邮件：主送/抄送先按酒店确认方式；以下字段为额外追加，与规则邮箱合并（不替换）
 * @param {string} [params.confirmVccEmail] 额外主送（可选）
 * @param {string} [params.ccVccEmail] 额外抄送（可选，多个英文逗号分隔）
 */
export function sendVccPdfEmail(id, params) {
  return request({
    url: '/fin/settlements/' + id + '/vcc/email',
    method: 'post',
    data: params || {}
  })
}

/** 切换已发卡/未发卡（与 vccMailSentAt 一致） */
export function updateVccCardIssued(id, data) {
  return request({
    url: '/fin/settlements/' + id + '/vcc/card-issued',
    method: 'post',
    data: data || {}
  })
}



// WEBPACK FOOTER //
// ./src/api/finSettlement.js